import React from "react";
import { Route, Redirect, useHistory } from "react-router-dom";
import auth from "../auth/auth";
import TopNavBar from "../components/insurance/navigation/topNavbar";
import { InsurerRoleIds } from "../constants/insurance/constant"
import { RouteToDashboard } from "../services/insurance/common";

export const ProtectedRouteInsurance = ({ component: Component,  ...rest}) => {
  const history = useHistory()
  const [searchDetails, setSearchDetails] = React.useState(null);
  const [searchAPIDetails, setSearchAPIDetails] = React.useState(null);
  const [selectedProviders, setSelectedProviders] = React.useState([]);

  function searchById(value) {
    setSearchDetails(value);
    console.log("value",value)
  }

  function searchAPIDetailsFnc(value) {
    if([0,1].includes(value.requestedStatusId))
      RouteToDashboard(history,value.requestedStatusId, value);
      
    setSearchAPIDetails(value);
    console.log("value",value)
  }
  const providersUpdated = (value)=>{
    setSelectedProviders(value)
  }


if(!localStorage.getItem("access_token")){
  history.push('/login')
  return null}
else
  return (
    <div className="py-16">
      <div>
        <TopNavBar {...rest} onSearchById={searchById} onSearchedDetails={searchAPIDetailsFnc} onProvidersChanged={providersUpdated}></TopNavBar>
      </div>
      <div>
      <Route
            {...rest}
            render={props => {
              if (auth.isAuthenticated() && localStorage.getItem('user_details') && InsurerRoleIds.includes(JSON.parse(localStorage.getItem("user_details")).roleId)) {
        
                return <Component {...props} searchAppointment={searchDetails}  searchAPIValues={searchAPIDetails} selectedProviders={selectedProviders}/>;
              } else {
                return (
                  <Redirect
                    to={{
                      pathname: "/login",
                      state: {
                        from: props.location
                      }
                    }}
                  />
                );
              }
            }}
          />
      </div>
    </div>
  );
};
